import axios from 'axios';
import { constructServiceURL } from '../../../../../../utils/URLTools';

const apiFetchEdiRfidAuditExecutionDelete = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'deleteEdiRfidAuditExecution',
    stub: process.env.useStubbedEndpoints,
  });
  return axios.delete(serviceUrl, {
    data: {
      executionIds: payload.params.executionIds,
    },
  });
};

export default apiFetchEdiRfidAuditExecutionDelete;
